import { connect } from 'react-redux';
import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import '../CreateService/CreateService.css';
import CloseIcon from '@mui/icons-material/Close';
import { createProject, editProject, fetchProjectDetails } from '../../store/app/apis';
import Toast from 'light-toast';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

function CreateProject({ projectList, createProject, editProject, fetchProjectDetails, ...props }) {
  const [anchorEl, setAnchorEl] = useState(props.anchorEl);
  const open = Boolean(anchorEl);
  const [state, setState] = useState({
    title: '',
    hookid: '',
    dashboard: '',
    baseurl: '',
  });

  const cancelPop = () => {
    setAnchorEl(null);
    props.onClose();
  };

  const handleNameChange = (e) => {
    setState((prev) => ({
      ...prev,
      title: e.target.value,
    }));
  };

  const handleHookidChange = (e) => {
    setState((prev) => ({
      ...prev,
      hookid: e.target.value,
    }));
  };
  const handleDashboardNameChange = (e) => {
    setState((prev) => ({
      ...prev,
      dashboard: e.target.value,
    }));
  };
  const handleBaseUrlChange = (e) => {
    setState((prev) => ({
      ...prev,
      baseurl: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (state.title === '') {
      Toast.fail('Please enter all details!');
    } else {
      if (props.id) {
        editProject({
          id: props.id,
          ...state,
        }).then((res) => {
          cancelPop();
        });

        return;
      }
      createProject(state).then((res) => {
        setState((prev) => ({
          ...prev,
          title: '',
          hookid: '',
          dashboard: '',
          baseurl: '',
        }));
        cancelPop();
      });
    }
  };

  useEffect(() => {
    if (!props.id) return;
    if (projectList?.length !== 0) setState(projectList?.find((project) => project.id === props.id));
    else {
      fetchProjectDetails(props.id).then((res) => {
        setState(res);
      });
    }
  }, [props.id]);

  useEffect(() => {
    setAnchorEl(props.anchorEl);
  }, [props.anchorEl]);

  return (
    <>
      <Dialog id="create-popover" open={open} onClose={cancelPop}>
        <Box
          sx={{
            padding: '20px',
          }}
        >
          <div className="formTitle">
            <h3>Project Form </h3>
            <CloseIcon onClick={cancelPop} sx={{ cursor: 'pointer' }} />
          </div>

          <form>
            <div className="forminput">
              <label>Enter Title</label>
              <span className="redstar">*</span>
              <TextField
                id="outlined-basic"
                onChange={handleNameChange}
                placeholder="Title"
                value={state?.title}
                variant="outlined"
              />
            </div>
            <div className="forminput">
              <label>Enter Hookid</label>
              <TextField
                id="outlined-basic"
                onChange={handleHookidChange}
                placeholder="Hook ID"
                value={state?.hookid}
                variant="outlined"
              />
            </div>
            <div className="forminput">
              <FormControl sx={{ display: 'flex', minWidth: 140, backgroundColor: 'white' }} size="small">
                Enter Dashboard Name
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  onChange={handleDashboardNameChange}
                  value={state?.dashboard}
                >
                  <MenuItem value={'DAM'}>DAM</MenuItem>
                  <MenuItem value={'Live Editor'}>Live Editor</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="forminput">
              <label>Enter Baseurl</label>
              <TextField
                id="outlined-basic"
                onChange={handleBaseUrlChange}
                placeholder="Baseurl"
                value={state?.baseurl}
                variant="outlined"
              />
            </div>
            <div className="buttonscancel">
              <button onClick={cancelPop}>Cancel</button>
              <button variant="contained" onClick={handleSubmit}>
                {props.id ? 'Edit' : 'Add'}
              </button>
            </div>
          </form>
        </Box>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  projectList: state.app.projectList,
});

const mapDispatchToProps = { createProject, editProject, fetchProjectDetails };

export default connect(mapStateToProps, mapDispatchToProps)(CreateProject);
